var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"upload-progress"},[(_vm.preparing)?[_vm._m(0)]:[_c('div',{staticClass:"progress-bar",style:({ width: `${_vm.progress}%` })}),_c('div',{staticClass:"progress-text"},[_vm._v(_vm._s(_vm.progressText))])]],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preparation-message"},[_c('div',{staticClass:"preparation-spinner"}),_c('span',[_vm._v("Preparing for upload...")])])
}]

export { render, staticRenderFns }